import { render, staticRenderFns } from "./teamStyle.vue?vue&type=template&id=4cc7e7b3&scoped=true&"
import script from "./teamStyle.vue?vue&type=script&lang=js&"
export * from "./teamStyle.vue?vue&type=script&lang=js&"
import style0 from "./teamStyle.vue?vue&type=style&index=0&id=4cc7e7b3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc7e7b3",
  null
  
)

export default component.exports